// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"909":"66578552","923":"55b53562"}[chunkId] + ".chunk.js";
};